import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, NgZone, OnInit, SimpleChanges, ViewChild, OnDestroy } from '@angular/core';
import { take, filter, takeUntil } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileUploader } from 'ng2-file-upload';
import { Constant } from 'src/app/constant/constant';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { LoaderService } from 'src/app/services/loader.service';
import { WhatsappChatService } from 'src/app/services/whatsapp-chat.service';
import { MediaPickerDialogComponent } from '../media-picker-dialog/media-picker-dialog.component';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { DownloadImageService } from 'src/app/services/download-image.service';
import { ImageZoomComponent } from '../image-zoom/image-zoom.component';
import { WhatsAppAssigneUserComponent } from '../whats-app-assigne-user/whats-app-assigne-user.component';
import { WhatsappBlockService } from 'src/app/services/whatsapp-block.service';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { WhatsappTemplateService } from 'src/app/services/whatsapp-template.service';

export interface Chat {
  id: number;
  name: string;
  lastMessage: string;
  time: string;
  unread: boolean;
  isGroup: boolean;
  avatar?: string;
  messages: Message[];
}

export interface Message {
  id: number;
  text: string;
  time: string;
  sent: boolean;
  received: boolean;
  read: boolean;
  isMedia?: boolean;
  mediaUrl?: string;
}

export const CHATS: Chat[] = [
  {
    id: 1,
    name: 'Mom',
    lastMessage: 'Good Morning',
    time: '10:53 am',
    unread: false,
    isGroup: false,
    messages: [
      {
        id: 1,
        text: 'Good Morning',
        time: '10:53 am',
        sent: false,
        received: true,
        read: true,
      },
    ],
  },
  {
    id: 2,
    name: 'CALSOFT QA Team',
    lastMessage:
      'Ajith bro Calsoft: 💤️ cnn new registration failed @Balaji A...',
    time: '10:40 am',
    unread: true,
    isGroup: true,
    messages: [
      {
        id: 1,
        text: 'Ajith bro Calsoft: 💤️ cnn new registration failed @Balaji A...',
        time: '10:40 am',
        sent: false,
        received: true,
        read: false,
      },
    ],
  },
  {
    id: 3,
    name: 'Iyawaya Akka Calsoft',
    lastMessage: 'RealLayout',
    time: 'Yesterday',
    unread: false,
    isGroup: false,
    messages: [
      {
        id: 1,
        text: 'RealLayout',
        time: 'Yesterday',
        sent: true,
        received: false,
        read: true,
      },
    ],
  },
  {
    id: 4,
    name: 'Fahishrowniebee Group 5',
    lastMessage: 'Fahia Brownie Bee 💤️ Photo',
    time: '10:07 am',
    unread: true,
    isGroup: true,
    messages: [
      {
        id: 1,
        text: 'Fahia Brownie Bee 💤️ Photo',
        time: '10:07 am',
        sent: false,
        received: true,
        read: false,
        isMedia: true,
        mediaUrl: 'https://example.com/photo.jpg',
      },
    ],
  },
  {
    id: 5,
    name: 'Selfish Bro',
    lastMessage: 'Payup off',
    time: 'Yesterday',
    unread: false,
    isGroup: false,
    messages: [
      {
        id: 1,
        text: 'Payup off',
        time: 'Yesterday',
        sent: true,
        received: false,
        read: true,
      },
    ],
  },
  {
    id: 6,
    name: 'Bal Murugan ama',
    lastMessage: 'JOURNAL',
    time: 'Yesterday',
    unread: false,
    isGroup: false,
    messages: [
      {
        id: 1,
        text: 'JOURNAL',
        time: 'Yesterday',
        sent: true,
        received: false,
        read: true,
      },
    ],
  },
  {
    id: 7,
    name: 'KENBFC',
    lastMessage: 'Dest customer, Thank you for choosing KreditBee...',
    time: 'Archived',
    unread: false,
    isGroup: false,
    messages: [
      {
        id: 1,
        text: 'Dest customer, Thank you for choosing KreditBee...',
        time: 'Archived',
        sent: false,
        received: true,
        read: true,
      },
    ],
  },
];

@Component({
  selector: 'calsoft-whatsapp-chat-details',
  templateUrl: './whatsapp-chat-details.component.html',
  styleUrls: ['./whatsapp-chat-details.component.scss'],
  host: {
    'style': 'display: flex; flex-direction: column; height: 100%; width: 100%; overflow: hidden;'
  }
})
export class WhatsappChatDetailsComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';

  whatsappMessageLog: any;
  chatDetails: any;
  showScrollButton = false;

  // ── Infinite scroll (older messages) ─────────────────────────────────────
  pageMsg = 0;
  isLoadingMoreMsg: boolean = false;
  hasMoreMessages: boolean = true;
  lastLoadedMessageIndex: number = 0; // Or whatever you use to track pagination
  
  allTemplates: any[] = [];
  /** Numeric DB id of the contact — set after initial load, used by getChatHistoryByContactId */
  numericContactId: number | null = null;
  // ─────────────────────────────────────────────────────────────────────────

  isEmptyChat = false;
  mobileView = false;
  previousWidth = 0;
  selectedContact: any = null;
  contactUid: any;
  showMainMeu: boolean = false;
  searchQuery: string = '';
  groupedSearchResults: any[] = [];
  highlightedMessageId: string | null = null;
  searchResults: any[] = [];
  currentMatchIndex: number = 0;
  showSearchPanel: boolean = false;
  whatsapplogs: any;
  @ViewChild("myInput") myInputVariable: ElementRef;
  NotBlocked: boolean = true;
  canReply: boolean = true;
  isSending: boolean = false;
  messageText: string = '';
  replyWindowClosesAt: Date | null = null;
  blockedUsers: string[] = [];
  remainingTime: string = '';
  isLimitExceeded: boolean = false;
  maxCharLimit = 3999;
  showCharLimitPopup = false;
  @ViewChild('chatListContainer', { static: false }) chatListContainer: ElementRef;

  @ViewChild('inputContainer') inputContainer!: ElementRef;
  inputHeight: number = 60;
  showCannotReplyWarning: boolean = false;
  isBlocked: any = 0;
  private timeUpdateInterval: any;
  showEmojiPicker = false;

  @ViewChild('msgInput') msgInput: ElementRef<HTMLTextAreaElement>;

  @ViewChild('messagesContainer') private messagesContainer!: ElementRef;
  crmSettingsData: any;
  whatsappVendorId: any;

  selectedContactUid: string | null = null;

  /** Cache of original media URL → resolved blob: URL */
  mediaUrlCache: Map<string, string> = new Map();
  /** Tracks which URLs are currently being fetched to avoid duplicate requests */
  private fetchingUrls: Set<string> = new Set();

  constructor(private whatsappservice: WhatsappChatService,
    private whatsappTemplateService: WhatsappTemplateService,
    private ecryptService: EcryptServiceService,
    private cdr: ChangeDetectorRef,
    private loaderService: LoaderService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private downloadImageService: DownloadImageService,
    private whatsappBlockService: WhatsappBlockService,
    private location: Location,
    private router: Router,
    private zone: NgZone
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }


  ngAfterViewInit() {

    setTimeout(() => {
      this.showScrollButton = true;
      this.cdr.detectChanges();
    });
  }

  cid: string;

  chats = CHATS;

  unreadUserMessages = 0;

  ngOnInit(): void {

    this.checkMobileView();
    window.addEventListener('resize', this.checkMobileView.bind(this));



    let values = localStorage.getItem(Constant.enterPriseKey);

    this.cid = "&cid=" + values


    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encrypted);
        this.crmSettingsData = JSON.parse(decrypted);
        this.whatsappVendorId = this.crmSettingsData.whatsappVendorId;
      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }
    if (this.contactId) {
      this.loadChatData();
    }
  }


  checkMobileView() {
    const width = window.innerWidth;
    if (width !== this.previousWidth) {
      this.mobileView = width <= 768;
      this.previousWidth = width;

      // Reset view on desktop
      if (!this.mobileView) {
        this.selectedContact = null;
        localStorage.removeItem("HideMainMenu")
      }
      if (this.showMainMeu == true && this.mobileView && this.selectedContact) {
        let str = "true";
        localStorage.setItem("HideMainMenu", str);
      }
      if (this.mobileView && this.selectedContact == null) {
        localStorage.removeItem("HideMainMenu")
      }
    }
  }

  phoneNo: any;

  private loadChatData(): void {
    console.log("Loading data for contact:", this.contactId);
    let processedContactId = this.contactId;
    if (this.isFromPhone) {
      if (!this.contactId.startsWith('91') && !this.contactId.startsWith('+91')) {
        processedContactId = '91' + this.contactId;
      }

      this.phoneNo = processedContactId

      this.getChatConversionByPhoneno(processedContactId);
    } else {
      this.getChatConversation(processedContactId);
    }
  }


  checkScrollPosition() {
    if (this.messagesContainer) {
      const element = this.messagesContainer.nativeElement;
      const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

      // Defer mutation to outside Angular's change-detection cycle (prevents NG0100)
      setTimeout(() => {
        this.showScrollButton = !atBottom;

        // Trigger infinite scroll when near the top of the message history
        if (element.scrollTop <= 60 && !this.isLoadingMoreMsg && this.hasMoreMessages && this.numericContactId) {
          this.loadOlderMessages();
        }
      }, 0);
    }
  }

  scrollToBottom(): void {
    try {
      if (this.messagesContainer) {
        const el = this.messagesContainer.nativeElement;
        el.scroll({
          top: el.scrollHeight,
          behavior: 'auto' // use 'auto' to instantly go to bottom
        });
      }
    } catch (err) {
      console.error(err);
    }
  }

  loadOlderMessages(): void {
    if (!this.numericContactId || this.isLoadingMoreMsg || !this.hasMoreMessages) return;

    this.isLoadingMoreMsg = true;
    const nextPage = this.pageMsg + 1;
    const element = this.messagesContainer?.nativeElement;
    const previousScrollHeight = element ? element.scrollHeight : 0;

    this.whatsappservice.getChatHistoryByContactId(this.numericContactId, nextPage, this.size)
      .subscribe((data: any) => {
        const rawMessages: any[] = data?.content || [];
        const isLastPage: boolean = data?.last ?? true;

        if (rawMessages.length === 0) {
          this.hasMoreMessages = false;
          this.isLoadingMoreMsg = false;
          return;
        }

        // API returns DESC — reverse so oldest renders at the top
        const newMessages = [...rawMessages].reverse();

        // ── Full message-parsing pipeline ──────────────────────────────────
        const processed = newMessages.map(msg => {
          if (msg.data) {
            try {
              const parsed = JSON.parse(msg.data);

              // Handle full template payloads that already exist in msg.data
              if (parsed.template_proforma) {
                msg.templatePreviewData = { data: JSON.stringify({ template: parsed.template_proforma }) };
              }
              // Handle messages (e.g. campaign) that have campaignData
              else if (msg.campaignData) {
                try {
                  const cData = typeof msg.campaignData === 'string' ? JSON.parse(msg.campaignData) : msg.campaignData;
                  msg.templatePreviewData = cData;
                } catch(e) {}
              }

              if (parsed.interaction_message_data) {
                const interactiveData = parsed.interaction_message_data;
                msg.interactiveType = interactiveData.interactive_type;
                msg.interactiveData = {
                  headerType: interactiveData.header_type, mediaLink: interactiveData.media_link,
                  bodyText: interactiveData.body_text, footerText: interactiveData.footer_text,
                  headerText: interactiveData.header_text, buttons: interactiveData.buttons,
                  listData: interactiveData.list_data, ctaData: interactiveData.cta_url
                };
                if (interactiveData.header_type && ['image','video','audio','document'].includes(interactiveData.header_type)) {
                  msg.media = { mediaUrl: interactiveData.media_link, extension: this.getFileExtension(interactiveData.media_link) };
                }
                switch (msg.interactiveType) {
                  case 'button': msg.buttonData = { buttons: interactiveData.buttons, bodyText: interactiveData.body_text, footerText: interactiveData.footer_text, headerText: interactiveData.header_text, headerType: interactiveData.header_type, mediaLink: interactiveData.media_link }; break;
                  case 'list': msg.listData = { buttonText: interactiveData.list_data?.button_text, sections: this.parseSections(interactiveData.list_data?.sections), bodyText: interactiveData.body_text, footerText: interactiveData.footer_text, headerText: interactiveData.header_text }; break;
                  case 'cta_url': msg.ctaData = { displayText: interactiveData.cta_url?.display_text, url: interactiveData.cta_url?.url, bodyText: interactiveData.body_text, footerText: interactiveData.footer_text, headerText: interactiveData.header_text }; break;
                }
              }
              if (parsed.template_proforma) {
                const components = (parsed.template_proforma.components || []);
                msg.templateComponents = {};
                components.forEach((comp: any) => {
                  switch (comp.type) {
                    case 'HEADER': msg.templateComponents.header = { type: comp.format?.toLowerCase() || 'text', text: comp.text || '', example: comp.example?.header_handle?.[0] || '' }; break;
                    case 'BODY': msg.templateComponents.body = comp.text || ''; break;
                    case 'FOOTER': msg.templateComponents.footer = comp.text || ''; break;
                    case 'BUTTONS': msg.templateComponents.buttons = comp.buttons || []; break;
                  }
                });
                if (parsed.template_components) {
                  parsed.template_components.forEach((comp: any) => {
                    switch (comp.type) {
                      case 'HEADER': msg.templateComponents.header = { type: comp.format?.toLowerCase() || 'text', text: comp.text || '', example: comp.example?.header_handle?.[0] || '', url: msg.templateComponents.header?.url || '' }; break;
                      case 'BODY': msg.templateComponents.body = comp.text || ''; break;
                      case 'FOOTER': msg.templateComponents.footer = comp.text || ''; break;
                      case 'BUTTONS': msg.templateComponents.buttons = comp.buttons || []; break;
                    }
                  });
                }
                if (parsed.template_component_values) {
                  parsed.template_component_values.forEach((compVal: any) => {
                    if (compVal.type === 'header' && compVal.parameters?.length) {
                      const param = compVal.parameters[0];
                      if (param.type === 'location') { msg.templateComponents.location = { name: param.location?.name || '', address: param.location?.address || '', latitude: param.location?.latitude || '', longitude: param.location?.longitude || '' }; }
                      if (msg.templateComponents.header) {
                        const link = param.image?.link || param.video?.link || param.document?.link;
                        if (link) { const u = new URL(link); u.searchParams.delete('cid'); msg.templateComponents.header.url = decodeURIComponent(u.toString()); }
                        else if (param.text) { msg.templateComponents.header.text = param.text; }
                      }
                    }
                    if (compVal.type === 'body' && compVal.parameters?.length) {
                      parsed.template_components?.forEach((comp: any) => {
                        if (comp.type === 'BODY' && comp.text) {
                          let bodyText = comp.text.replace(/&#123;/g, '{').replace(/&#125;/g, '}');
                          const bv = parsed.template_component_values?.find((v: any) => v.type?.toLowerCase() === 'body');
                          if (bv?.parameters?.length) { bv.parameters.forEach((p: any, i: number) => { if (p.type === 'text' && p.text) { bodyText = bodyText.replace(new RegExp(`{{\\s*${i+1}\\s*}}`, 'g'), p.text.trim()); } }); }
                          msg.templateComponents.body = bodyText;
                        }
                      });
                    }
                  });
                }
              }
              if (parsed.webhook_responses && msg?.message === '' && !msg?.interactiveType?.length) {
                try { msg.WebHookText = parsed.webhook_responses.incoming[0].changes[0].value.messages[0].text.body; } catch (_) {}
              }
              const media = parsed.media_values;
              let mediaUrl = media?.link;
              let mediaType = media?.type;
              let mediaMimeType = media?.mime_type;
              let mediaCaption = media?.caption || '';
              let mediaFilename = media?.file_name || '';

              if (!mediaUrl && parsed.webhook_responses?.incoming?.[0]?.changes?.[0]?.value?.messages?.[0]) {
                const whMsg = parsed.webhook_responses.incoming[0].changes[0].value.messages[0];
                const whType = whMsg.type;
                if (whType && whMsg[whType]) {
                  mediaUrl = whMsg[whType].url;
                  mediaType = whType;
                  mediaMimeType = whMsg[whType].mime_type;
                  mediaCaption = whMsg[whType].caption || '';
                  mediaFilename = whMsg[whType].filename || '';
                }
              }

              if (mediaUrl && (mediaType || mediaMimeType)) {
                let type = mediaType;
                if ((type === 'document' || !type) && mediaMimeType) {
                  const m = mediaMimeType.split('/')[0];
                  if (['image','video','audio'].includes(m)) type = m;
                }
                msg.mediaData = { type, url: mediaUrl.trim(), caption: mediaCaption || '', mimeType: mediaMimeType || '' };
                let extMatch = (mediaFilename || '').match(/\.([a-zA-Z0-9]+)(?=[?#]|$)/);
                if (!extMatch) {
                  extMatch = mediaUrl.match(/\.([a-zA-Z0-9]+)(?=[?#]|$)/);
                }
                msg.mediaData.extension = extMatch ? extMatch[1].toLowerCase() : '';
                if (!msg.mediaData.extension && mediaMimeType) {
                  const parts = mediaMimeType.split('/');
                  if (parts.length > 1) {
                    let ext = parts[1].toLowerCase();
                    if (ext === 'plain') ext = 'txt';
                    if (ext === 'mpeg') ext = 'mp3';
                    msg.mediaData.extension = ext;
                  }
                }
              } else { msg.mediaData = null; }
            } catch (e) { console.error('Error parsing older message data', e); }
          }
          return msg;
        });
        // ───────────────────────────────────────────────────────────────────

        const existingIds = new Set((this.whatsappMessageLog || []).map((m: any) => m.uid));
        const toAdd = processed.filter((m: any) => !existingIds.has(m.uid));

        if (toAdd.length > 0) {
          this.whatsappMessageLog = [...toAdd, ...(this.whatsappMessageLog || [])];
          this.pageMsg = nextPage;
          setTimeout(() => {
            if (element) { element.scrollTop = element.scrollHeight - previousScrollHeight; }
            this.isLoadingMoreMsg = false;
          }, 0);
        } else {
          this.hasMoreMessages = false;
          this.isLoadingMoreMsg = false;
        }

        if (isLastPage) this.hasMoreMessages = false;
      }, () => {
        this.isLoadingMoreMsg = false;
      });
  }

  @Input() contactId: any;
  @Input() isFromPhone = false;

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  sortParam: any = 'id' + "," + Constant.Dsc;

  getChatConversation(contactId) {
    if (this.whatsappVendorId != undefined) {
      this.whatsappservice.getAllWhatsAppChat(contactId, this.page, this.size, this.sortParam)
        .subscribe((data: any) => {
          if (data && data.chatData && data.chatData.contactDetails && data.chatData.contactDetails.length > 0) {

            this.chatDetails = data.chatData.contactDetails[0];
            // Store numeric id for infinite scroll (older messages)
            this.numericContactId = this.chatDetails?.id ?? null;
            
            this.isBlocked = 0;


            if (this.chatDetails.isBlocked != undefined) {

              this.isBlocked = this.chatDetails.isBlocked;
            }

            //unread handle
            if (this.chatDetails.lastUnreadMessageCount > 0) {
              if (this.unreadUserMessages > 0) {
                this.unreadUserMessages--;
              }
            }


            if (this.chatDetails.whatsappMessageLog) {
              this.whatsappMessageLog = this.chatDetails.whatsappMessageLog;

              this.whatsappMessageLog = this.whatsappMessageLog.map(msg => {
                if (msg.data) {
                  try {
                    const parsed = JSON.parse(msg.data);

                    // Handle full template payloads that already exist in msg.data
                    if (parsed.template_proforma) {
                      msg.templatePreviewData = { data: JSON.stringify({ template: parsed.template_proforma }) };
                    }
                    // Handle messages (e.g. campaign) that have campaignData
                    else if (msg.campaignData) {
                      try {
                        const cData = typeof msg.campaignData === 'string' ? JSON.parse(msg.campaignData) : msg.campaignData;
                        msg.templatePreviewData = cData;
                      } catch(e) {}
                    }

                    if (parsed.interaction_message_data) {
                      const interactiveData = parsed.interaction_message_data;
                      msg.interactiveType = interactiveData.interactive_type;


                      msg.interactiveData = {
                        headerType: interactiveData.header_type,
                        mediaLink: interactiveData.media_link,
                        bodyText: interactiveData.body_text,
                        footerText: interactiveData.footer_text,
                        headerText: interactiveData.header_text,
                        buttons: interactiveData.buttons,
                        listData: interactiveData.list_data,
                        ctaData: interactiveData.cta_url
                      };

                      // Handle media if present
                      if (interactiveData.header_type && ['image', 'video', 'audio', 'document'].includes(interactiveData.header_type)) {
                        msg.media = {
                          mediaUrl: interactiveData.media_link,
                          extension: this.getFileExtension(interactiveData.media_link)
                        };
                      }
                      switch (msg.interactiveType) {
                        case 'button':
                          msg.buttonData = {
                            buttons: interactiveData.buttons,
                            bodyText: interactiveData.body_text,
                            footerText: interactiveData.footer_text,
                            headerText: interactiveData.header_text,
                            headerType: interactiveData.header_type,
                            mediaLink: interactiveData.media_link
                          };
                          break;

                        case 'list':
                          msg.listData = {
                            buttonText: interactiveData.list_data?.button_text,
                            sections: this.parseSections(interactiveData.list_data?.sections),
                            bodyText: interactiveData.body_text,
                            footerText: interactiveData.footer_text,
                            headerText: interactiveData.header_text
                          };
                          break;

                        case 'cta_url':
                          msg.ctaData = {
                            displayText: interactiveData.cta_url?.display_text,
                            url: interactiveData.cta_url?.url,
                            bodyText: interactiveData.body_text,
                            footerText: interactiveData.footer_text,
                            headerText: interactiveData.header_text
                          };
                          break;
                      }

                    }

                    if (parsed.template_proforma) {
                      const template = parsed.template_proforma;
                      const components = template.components || [];

                      // Extract all template components
                      msg.templateComponents = {};

                      components.forEach((comp: any) => {
                        switch (comp.type) {
                          case 'HEADER':
                            msg.templateComponents.header = {
                              type: comp.format?.toLowerCase() || 'text',
                              text: comp.text || '',
                              example: comp.example?.header_handle?.[0] || ''
                            };
                            break;
                          case 'BODY':
                            msg.templateComponents.body = comp.text || '';
                            break;
                          case 'FOOTER':
                            msg.templateComponents.footer = comp.text || '';
                            break;
                          case 'BUTTONS':
                            msg.templateComponents.buttons = comp.buttons || [];
                            break;
                        }
                      });
                      // If we have template components from webhook
                      if (parsed.template_components) {
                        msg.templateComponents = msg.templateComponents || {};

                        parsed.template_components.forEach((comp: any) => {
                          switch (comp.type) {
                            case 'HEADER':
                              msg.templateComponents.header = {
                                type: comp.format?.toLowerCase() || 'text',
                                text: comp.text || '',
                                example: comp.example?.header_handle?.[0] || '',
                                url: msg.templateComponents.header.url || ''
                              };

                              break;
                            case 'BODY':
                              msg.templateComponents.body = comp.text || '';
                              break;
                            case 'FOOTER':
                              msg.templateComponents.footer = comp.text || '';
                              break;
                            case 'BUTTONS':
                              msg.templateComponents.buttons = comp.buttons || [];
                              break;
                          }
                        });
                      }
                      // Handle template component values
                      if (parsed.template_component_values) {
                        parsed.template_component_values.forEach((compVal: any) => {
                          if (compVal.type === 'header' && compVal.parameters?.length) {
                            const param = compVal.parameters[0];
                            if (param.type === 'location') {
                              msg.templateComponents = msg.templateComponents || {};
                              msg.templateComponents.location = {
                                name: param.location?.name || '',
                                address: param.location?.address || '',
                                latitude: param.location?.latitude || '',
                                longitude: param.location?.longitude || ''
                              };
                            }

                            if (msg.templateComponents.header) {
                              if (param.image?.link) {
                                const originalUrl = param.image.link;

                                // Parse the URL
                                const urlObj = new URL(originalUrl);

                                // Delete all `cid` parameters
                                urlObj.searchParams.delete('cid');

                                // Get the cleaned URL
                                const cleanedUrl = urlObj.toString();

                                console.log(cleanedUrl);
                                msg.templateComponents.header.url = decodeURIComponent(cleanedUrl);
                              } else if (param.video?.link) {
                                const originalUrl = param.video.link;

                                // Parse the URL
                                const urlObj = new URL(originalUrl);

                                // Delete all `cid` parameters
                                urlObj.searchParams.delete('cid');

                                // Get the cleaned URL
                                const cleanedUrl = urlObj.toString();

                                console.log(cleanedUrl);
                                msg.templateComponents.header.url = decodeURIComponent(cleanedUrl);

                              } else if (param.document?.link) {
                                const originalUrl = param.document.link;

                                // Parse the URL
                                const urlObj = new URL(originalUrl);

                                // Delete all `cid` parameters
                                urlObj.searchParams.delete('cid');

                                // Get the cleaned URL
                                const cleanedUrl = urlObj.toString();

                                console.log(cleanedUrl);
                                msg.templateComponents.header.url = decodeURIComponent(cleanedUrl);

                              } else if (param.text) {
                                msg.templateComponents.header.text = param.text;
                              }
                            }
                          }
                          if (compVal.type === 'body' && compVal.parameters?.length) {
                            msg.templateComponents = msg.templateComponents || {};

                            parsed.template_components.forEach((comp: any) => {
                              if (comp.type === 'BODY' && comp.text) {
                                let bodyText = comp.text;

                                // Find matching component values for BODY
                                const bodyCompVal = parsed.template_component_values?.find(
                                  (val: any) => val.type?.toLowerCase() === 'body'
                                );

                                if (bodyCompVal?.parameters?.length) {
                                  // Normalize text (remove encoded braces)
                                  bodyText = bodyText.replace(/&#123;/g, '{').replace(/&#125;/g, '}');

                                  bodyCompVal.parameters.forEach((param: any, index: number) => {
                                    if (param.type === 'text' && param.text) {
                                      // Match {{ 1 }} with possible spaces
                                      const placeholder = new RegExp(`{{\\s*${index + 1}\\s*}}`, 'g');
                                      bodyText = bodyText.replace(placeholder, param.text.trim());
                                    }
                                  });
                                }

                                msg.templateComponents = msg.templateComponents || {};
                                msg.templateComponents.body = bodyText;
                              }
                            });
                          }
                        });
                      }
                    }


                    if (parsed.webhook_responses && msg?.message == "" && msg?.interactiveType?.length == 0) {
                      let incoming = parsed.webhook_responses.incoming[0];
                      let changes = incoming.changes[0];
                      let changesMessages = changes.value.messages[0];
                      let webHookText = changesMessages.text.body;
                      msg.WebHookText = webHookText;
                    }
                    const media = parsed.media_values;
                    let mediaUrl = media?.link;
                    let mediaType = media?.type;
                    let mediaMimeType = media?.mime_type;
                    let mediaCaption = media?.caption || '';
                    let mediaFilename = media?.file_name || '';

                    if (!mediaUrl && parsed.webhook_responses?.incoming?.[0]?.changes?.[0]?.value?.messages?.[0]) {
                      const whMsg = parsed.webhook_responses.incoming[0].changes[0].value.messages[0];
                      const whType = whMsg.type;
                      if (whType && whMsg[whType]) {
                        mediaUrl = whMsg[whType].url;
                        mediaType = whType;
                        mediaMimeType = whMsg[whType].mime_type;
                        mediaCaption = whMsg[whType].caption || '';
                        mediaFilename = whMsg[whType].filename || '';
                      }
                    }

                    if (mediaUrl && (mediaType || mediaMimeType)) {
                      let type = mediaType;
                      if ((type === 'document' || !type) && mediaMimeType) {
                        const mimeMain = mediaMimeType.split('/')[0];
                        if (['image', 'video', 'audio'].includes(mimeMain)) {
                          type = mimeMain;
                        }
                      }

                      msg.mediaData = {
                        type,
                        url: mediaUrl.trim(),
                        caption: mediaCaption || '',
                        mimeType: mediaMimeType || ''
                      };

                      let extensionMatch = (mediaFilename || '').match(/\.([a-zA-Z0-9]+)(?=[?#]|$)/);
                      if (!extensionMatch) {
                        extensionMatch = mediaUrl.match(/\.([a-zA-Z0-9]+)(?=[?#]|$)/);
                      }
                      msg.mediaData.extension = extensionMatch ? extensionMatch[1].toLowerCase() : '';
                      if (!msg.mediaData.extension && mediaMimeType) {
                        const parts = mediaMimeType.split('/');
                        if (parts.length > 1) {
                          let ext = parts[1].toLowerCase();
                          if (ext === 'plain') ext = 'txt';
                          if (ext === 'mpeg') ext = 'mp3';
                          msg.mediaData.extension = ext;
                        }
                      }
                    } else {
                      msg.mediaData = null;
                    }
                  } catch (e) {
                    console.error('Error parsing message data', e);
                  }
                }
                return msg;
              });

              // FIX: Calculate initial pageMsg based on actual messages returned
              const logLength = this.whatsappMessageLog ? this.whatsappMessageLog.length : 0;
              this.pageMsg = logLength > 0 ? Math.ceil(logLength / this.size) - 1 : 0;
              this.hasMoreMessages = true;

              // Reverse the DESC-sorted messages to show them chronologically (oldest to newest)
              this.whatsappMessageLog = this.whatsappMessageLog.reverse();

              this.checkCanReply();
              setTimeout(() => {
                if (this.messagesContainer) {
                  const el = this.messagesContainer.nativeElement;
                  el.scrollTop = el.scrollHeight; 
                }
              }, 200);

            } else {
              console.log("No whatsappMessageLog available");
              this.whatsappMessageLog = [];
              this.isEmptyChat = true;
            }
          } else {
            console.log("No contact details found");
            this.whatsappMessageLog = [];
            this.isEmptyChat = true;
          }
        });
    }

  }

  getChatConversionByPhoneno(contactId) {

    if (this.whatsappVendorId != undefined) {
      this.whatsappservice.getMessagesbyPhoneno(contactId)
        .subscribe((data: any) => {
          this.isEmptyChat = false;

          this.contactUid = data.contactUid;

          if (data && data.chatData && data.chatData.contactDetails && data.chatData.contactDetails.length > 0) {
            this.chatDetails = data.chatData.contactDetails[0];
            // Store numeric id for infinite scroll (older messages)
            this.numericContactId = this.chatDetails?.id ?? null;
            // pageMsg and hasMoreMessages will be set after processing the log log below

            if (this.chatDetails.whatsappMessageLog && this.chatDetails.whatsappMessageLog.length > 0) {
              this.whatsappMessageLog = this.chatDetails.whatsappMessageLog;



              this.whatsappMessageLog = this.whatsappMessageLog.map(msg => {
                if (msg.data) {
                  try {
                    const parsed = JSON.parse(msg.data);

                    // Handle full template payloads that already exist in msg.data
                    if (parsed.template_proforma) {
                      msg.templatePreviewData = { data: JSON.stringify({ template: parsed.template_proforma }) };
                    }
                    // Handle messages (e.g. campaign) that have campaignData
                    else if (msg.campaignData) {
                      try {
                        const cData = typeof msg.campaignData === 'string' ? JSON.parse(msg.campaignData) : msg.campaignData;
                        msg.templatePreviewData = cData;
                      } catch(e) {}
                    }

                    if (parsed.interaction_message_data) {
                      const interactiveData = parsed.interaction_message_data;
                      msg.interactiveType = interactiveData.interactive_type;


                      msg.interactiveData = {
                        headerType: interactiveData.header_type,
                        mediaLink: interactiveData.media_link,
                        bodyText: interactiveData.body_text,
                        footerText: interactiveData.footer_text,
                        headerText: interactiveData.header_text,
                        buttons: interactiveData.buttons,
                        listData: interactiveData.list_data,
                        ctaData: interactiveData.cta_url
                      };

                      // Handle media if present
                      if (interactiveData.header_type && ['image', 'video', 'audio', 'document'].includes(interactiveData.header_type)) {
                        msg.media = {
                          mediaUrl: interactiveData.media_link,
                          extension: this.getFileExtension(interactiveData.media_link)
                        };
                      }
                      switch (msg.interactiveType) {
                        case 'button':
                          msg.buttonData = {
                            buttons: interactiveData.buttons,
                            bodyText: interactiveData.body_text,
                            footerText: interactiveData.footer_text,
                            headerText: interactiveData.header_text,
                            headerType: interactiveData.header_type,
                            mediaLink: interactiveData.media_link
                          };
                          break;

                        case 'list':
                          msg.listData = {
                            buttonText: interactiveData.list_data?.button_text,
                            sections: this.parseSections(interactiveData.list_data?.sections),
                            bodyText: interactiveData.body_text,
                            footerText: interactiveData.footer_text,
                            headerText: interactiveData.header_text
                          };
                          break;

                        case 'cta_url':
                          msg.ctaData = {
                            displayText: interactiveData.cta_url?.display_text,
                            url: interactiveData.cta_url?.url,
                            bodyText: interactiveData.body_text,
                            footerText: interactiveData.footer_text,
                            headerText: interactiveData.header_text
                          };
                          break;
                      }

                    }

                    if (parsed.template_proforma) {
                      const template = parsed.template_proforma;
                      const components = template.components || [];

                      // Extract all template components
                      msg.templateComponents = {};

                      components.forEach((comp: any) => {
                        switch (comp.type) {
                          case 'HEADER':
                            msg.templateComponents.header = {
                              type: comp.format?.toLowerCase() || 'text',
                              text: comp.text || '',
                              example: comp.example?.header_handle?.[0] || ''
                            };
                            break;
                          case 'BODY':
                            msg.templateComponents.body = comp.text || '';
                            break;
                          case 'FOOTER':
                            msg.templateComponents.footer = comp.text || '';
                            break;
                          case 'BUTTONS':
                            msg.templateComponents.buttons = comp.buttons || [];
                            break;
                        }
                      });
                      // If we have template components from webhook
                      if (parsed.template_components) {
                        msg.templateComponents = msg.templateComponents || {};

                        parsed.template_components.forEach((comp: any) => {
                          switch (comp.type) {
                            case 'HEADER':
                              msg.templateComponents.header = {
                                type: comp.format?.toLowerCase() || 'text',
                                text: comp.text || '',
                                example: comp.example?.header_handle?.[0] || '',
                                url: msg.templateComponents.header.url || ''
                              };

                              break;
                            case 'BODY':
                              msg.templateComponents.body = comp.text || '';
                              break;
                            case 'FOOTER':
                              msg.templateComponents.footer = comp.text || '';
                              break;
                            case 'BUTTONS':
                              msg.templateComponents.buttons = comp.buttons || [];
                              break;
                          }
                        });
                      }
                      // Handle template component values
                      if (parsed.template_component_values) {
                        parsed.template_component_values.forEach((compVal: any) => {
                          if (compVal.type === 'header' && compVal.parameters?.length) {
                            const param = compVal.parameters[0];
                            if (param.type === 'location') {
                              msg.templateComponents = msg.templateComponents || {};
                              msg.templateComponents.location = {
                                name: param.location?.name || '',
                                address: param.location?.address || '',
                                latitude: param.location?.latitude || '',
                                longitude: param.location?.longitude || ''
                              };
                            }

                            if (msg.templateComponents.header) {
                              if (param.image?.link) {
                                const originalUrl = param.image.link;

                                // Parse the URL
                                const urlObj = new URL(originalUrl);

                                // Delete all `cid` parameters
                                urlObj.searchParams.delete('cid');

                                // Get the cleaned URL
                                const cleanedUrl = urlObj.toString();

                                console.log(cleanedUrl);
                                msg.templateComponents.header.url = decodeURIComponent(cleanedUrl);
                              } else if (param.video?.link) {
                                const originalUrl = param.video.link;

                                // Parse the URL
                                const urlObj = new URL(originalUrl);

                                // Delete all `cid` parameters
                                urlObj.searchParams.delete('cid');

                                // Get the cleaned URL
                                const cleanedUrl = urlObj.toString();

                                console.log(cleanedUrl);
                                msg.templateComponents.header.url = decodeURIComponent(cleanedUrl);

                              } else if (param.document?.link) {
                                const originalUrl = param.document.link;

                                // Parse the URL
                                const urlObj = new URL(originalUrl);

                                // Delete all `cid` parameters
                                urlObj.searchParams.delete('cid');

                                // Get the cleaned URL
                                const cleanedUrl = urlObj.toString();

                                console.log(cleanedUrl);
                                msg.templateComponents.header.url = decodeURIComponent(cleanedUrl);

                              } else if (param.text) {
                                msg.templateComponents.header.text = param.text;
                              }
                            }
                          }
                          if (compVal.type === 'body' && compVal.parameters?.length) {
                            msg.templateComponents = msg.templateComponents || {};

                            parsed.template_components.forEach((comp: any) => {
                              if (comp.type === 'BODY' && comp.text) {
                                let bodyText = comp.text;

                                // Find matching component values for BODY
                                const bodyCompVal = parsed.template_component_values?.find(
                                  (val: any) => val.type?.toLowerCase() === 'body'
                                );

                                if (bodyCompVal?.parameters?.length) {
                                  // Normalize text (remove encoded braces)
                                  bodyText = bodyText.replace(/&#123;/g, '{').replace(/&#125;/g, '}');

                                  bodyCompVal.parameters.forEach((param: any, index: number) => {
                                    if (param.type === 'text' && param.text) {
                                      // Match {{ 1 }} with possible spaces
                                      const placeholder = new RegExp(`{{\\s*${index + 1}\\s*}}`, 'g');
                                      bodyText = bodyText.replace(placeholder, param.text.trim());
                                    }
                                  });
                                }

                                msg.templateComponents = msg.templateComponents || {};
                                msg.templateComponents.body = bodyText;
                              }
                            });
                          }
                        });
                      }
                    }


                    if (parsed.webhook_responses && msg?.message == "" && msg?.interactiveType?.length == 0) {
                      let incoming = parsed.webhook_responses.incoming[0];
                      let changes = incoming.changes[0];
                      let changesMessages = changes.value.messages[0];
                      let webHookText = changesMessages.text.body;
                      msg.WebHookText = webHookText;
                    }
                    const media = parsed.media_values;
                    let mediaUrl = media?.link;
                    let mediaType = media?.type;
                    let mediaMimeType = media?.mime_type;
                    let mediaCaption = media?.caption || '';
                    let mediaFilename = media?.file_name || '';

                    if (!mediaUrl && parsed.webhook_responses?.incoming?.[0]?.changes?.[0]?.value?.messages?.[0]) {
                      const whMsg = parsed.webhook_responses.incoming[0].changes[0].value.messages[0];
                      const whType = whMsg.type;
                      if (whType && whMsg[whType]) {
                        mediaUrl = whMsg[whType].url;
                        mediaType = whType;
                        mediaMimeType = whMsg[whType].mime_type;
                        mediaCaption = whMsg[whType].caption || '';
                        mediaFilename = whMsg[whType].filename || '';
                      }
                    }

                    if (mediaUrl && (mediaType || mediaMimeType)) {
                      let type = mediaType;
                      if ((type === 'document' || !type) && mediaMimeType) {
                        const mimeMain = mediaMimeType.split('/')[0];
                        if (['image', 'video', 'audio'].includes(mimeMain)) {
                          type = mimeMain;
                        }
                      }

                      msg.mediaData = {
                        type,
                        url: mediaUrl.trim(),
                        caption: mediaCaption || '',
                        mimeType: mediaMimeType || ''
                      };

                      let extensionMatch = (mediaFilename || '').match(/\.([a-zA-Z0-9]+)(?=[?#]|$)/);
                      if (!extensionMatch) {
                        extensionMatch = mediaUrl.match(/\.([a-zA-Z0-9]+)(?=[?#]|$)/);
                      }
                      msg.mediaData.extension = extensionMatch ? extensionMatch[1].toLowerCase() : '';
                      if (!msg.mediaData.extension && mediaMimeType) {
                        const parts = mediaMimeType.split('/');
                        if (parts.length > 1) {
                          let ext = parts[1].toLowerCase();
                          if (ext === 'plain') ext = 'txt';
                          if (ext === 'mpeg') ext = 'mp3';
                          msg.mediaData.extension = ext;
                        }
                      }
                    } else {
                      msg.mediaData = null;
                    }
                  } catch (e) {
                    console.error('Error parsing message data', e);
                  }
                }
                return msg;
              });

              // FIX: Calculate initial pageMsg based on actual messages returned
              const logLength = this.whatsappMessageLog ? this.whatsappMessageLog.length : 0;
              this.pageMsg = logLength > 0 ? Math.ceil(logLength / this.size) - 1 : 0;
              this.hasMoreMessages = true;

              // Reverse the DESC-sorted messages to show them chronologically (oldest to newest)
              this.whatsappMessageLog = this.whatsappMessageLog.reverse();

              // Run scroll-to-bottom only once after Angular stabilizes to avoid
              // repeatedly forcing scroll to bottom when the user scrolls up.
              this.zone.onStable.pipe(take(1)).subscribe(() => {
                setTimeout(() => this.scrollToBottom(), 100);
              });
            } else {
              console.log("No whatsappMessageLog available");
              this.whatsappMessageLog = [];
              this.isEmptyChat = true;
            }
          } else {
            console.log("No contact details found");
            this.isEmptyChat = true;
            this.whatsappMessageLog = [];
          }
        }, error => {
          console.error("Error fetching chat by phone", error);
          this.isEmptyChat = true;
          this.whatsappMessageLog = [];
        });
    }
    else {
      this.isEmptyChat = true;
    }
  }

  getTemplateBody(message: any): string | null {
    if (!message.data) return null;

    try {
      const data = JSON.parse(message.data);
      if (data.template_proforma?.components) {
        const bodyComponent = data.template_proforma.components.find(
          (c: any) => c.type === 'BODY'
        );
        return bodyComponent?.text || null;
      }
      return null;
    } catch (e) {
      console.error('Error parsing message data', e);
      return null;
    }
  }

  formatMessageTime(timestamp: string): string {
    if (!timestamp) return '';

    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    const formattedHours = hours % 12 || 12;

    return `${formattedHours}:${minutes < 10 ? '0' + minutes : minutes} ${ampm}`;
  }

  formatMessageDate(timestamp: string): string {
    if (!timestamp) return '';

    const date = new Date(timestamp);
    const options: Intl.DateTimeFormatOptions = {
      // weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    };

    return date.toLocaleDateString('en-US', options);
  }

  formatFullDateTime(timestamp: string): string {
    if (!timestamp) return '';

    const date = new Date(timestamp);

    // Helper function for ordinal suffix (e.g., "st", "nd", "th")
    function getOrdinalSuffix(day: number): string {
      if (day > 3 && day < 21) return 'th'; // for 4-20
      switch (day % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    }

    // --- Date Parts ---
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    const weekday = weekdays[date.getDay()];
    const day = date.getDate();
    const dayWithSuffix = `${day}${getOrdinalSuffix(day)}`;
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    // --- Time Parts ---
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    const ampm = hours >= 12 ? 'pm' : 'am';
    const formattedHours = hours % 12 || 12; // Convert 0/24h to 12
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

    // --- Combine Parts ---
    const dateString = `${weekday} ${dayWithSuffix} ${month} ${year}`;
    const timeString = `${formattedHours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;

    return `${dateString} ${timeString}`;
  }


  getHighlightedText(text: string | null): string {
    if (!this.searchQuery || !text) return text || '';

    // Escape special regex characters
    const escapedQuery = this.searchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(escapedQuery, 'gi');
    console.log(text.replace(regex, match => `<span class="highlight">${match}</span>`));

    return text.replace(regex, match => `<span class="highlight">${match}</span>`);
  }

  scrollToMessage(message: any): void {
    this.highlightedMessageId = message.uid;

    setTimeout(() => {
      const element = document.getElementById(`message-${message.uid}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // Highlight animation
        element.classList.add('highlight-animate');
        setTimeout(() => {
          element.classList.remove('highlight-animate');
        }, 1000);
      }
    }, 0);
  }

  clearSearch(): void {
    this.searchQuery = '';
    this.searchResults = [];
    this.groupedSearchResults = [];
    this.currentMatchIndex = -1;
    this.highlightedMessageId = null;
    this.showSearchPanel = false;
  }

  onSearch(): void {
    if (!this.searchQuery.trim()) {
      this.clearSearch();
      return;
    }

    const query = this.searchQuery.toLowerCase();
    this.searchResults = this.whatsappMessageLog.filter(message => {
      const messageText = message.message?.toLowerCase() || '';
      const templateText = this.getTemplateBody(message)?.toLowerCase() || '';
      return messageText.includes(query) || templateText.includes(query);
    });
    this.groupSearchResults();

    this.showSearchPanel = true;

    // if (this.searchResults.length > 0) {
    //   this.currentMatchIndex = 0;
    //   this.highlightAndScrollToMatch();
    // } else {
    //   this.currentMatchIndex = -1;
    //   this.highlightedMessageId = null;
    // }
  }
  groupSearchResults(): void {
    const groupsMap = new Map<string, any[]>();

    this.searchResults.forEach(message => {
      const date = new Date(message.messagedAt).toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });

      if (!groupsMap.has(date)) {
        groupsMap.set(date, []);
      }

      groupsMap.get(date)?.push({
        ...message,
        // Store the original message for highlighting
        originalMessage: message.message || this.getTemplateBody(message) || ''
      });
    });

    this.groupedSearchResults = Array.from(groupsMap.entries()).map(([date, messages]) => ({
      date,
      messages
    }));
  }
  adjustTextAreaHeight(textarea?: HTMLTextAreaElement): void {
    const textAreaEl = textarea || this.msgInput?.nativeElement;
    if (!textAreaEl) return;

    // Auto-resize only — do not trigger scroll
    textAreaEl.style.height = 'auto';
    textAreaEl.style.height = textAreaEl.scrollHeight + 'px';

    // Character limit check
    if (textAreaEl.value.length > this.maxCharLimit) {
      this.isLimitExceeded = true;
      this.showCharLimitPopup = true;
      textAreaEl.value = textAreaEl.value.substring(0, this.maxCharLimit);
      this.messageText = textAreaEl.value;
      setTimeout(() => this.showCharLimitPopup = false, 3000);
    } else {
      this.isLimitExceeded = false;
      this.showCharLimitPopup = false;
    }
  }



  @ViewChild('chatContainer') chatContainer!: ElementRef<HTMLDivElement>;

  sendMessage(): void {
    if (this.isContactBlocked()) {
      console.warn('Message not sent. Contact is blocked.');
      return;
    }

    if (!this.messageText.trim() || this.isSending) {
      return;
    }

    if (!navigator.onLine) {
      console.warn("User is offline");
      this.snackBar.open("You're offline. Message not sent.", 'Close', { duration: 3000 });
      return;
    }

    this.loaderService.show();
    this.isSending = true;

    const body = {
      messageBody: this.messageText,
      contactUid: this.contactUid
    };

    // Save scroll position (optional safeguard)
    const prevScroll = this.messagesContainer?.nativeElement.scrollTop || 0;

    this.whatsappservice.sendMessage(body, this.whatsappVendorId).subscribe({
      next: (response) => {
        this.loaderService.hide();
        this.isSending = false;
        console.log('Message sent successfully:', response);

        // Clear input
        this.messageText = '';

        // Reset textarea height safely without triggering scroll jump
        if (this.msgInput) {
          const textArea = this.msgInput.nativeElement;
          requestAnimationFrame(() => {
            textArea.style.height = '40px'; // your default height
          });
        }

        // Refresh chat messages
        this.getChatConversionByPhoneno(this.phoneNo);

        // Wait for DOM update, then scroll to bottom smoothly
        setTimeout(() => {
          this.scrollToBottom();
        }, 200);

        this.checkCanReply();
      },
      error: (error) => {
        console.error('Error sending message:', error);
        this.loaderService.hide();
        this.isSending = false;

        if (!navigator.onLine) {
          this.snackBar.open("You're offline. Message not sent.", 'Close', { duration: 3000 });
        } else {
          this.snackBar.open("Failed to send message. Try again.", 'Close', { duration: 3000 });
        }
      }
    });
  }




  checkCanReply(): void {
    if (this.isBlocked === 1) {
      this.NotBlocked = false;
    } else {
      this.NotBlocked = true;
    }

    if (!this.whatsappMessageLog || this.whatsappMessageLog.length === 0) {
      this.canReply = false;
      this.showCannotReplyWarning = true;
      this.replyWindowClosesAt = null;
      this.remainingTime = '';
      return;
    }

    const incomingMessages = this.whatsappMessageLog.filter(
      (msg: any) => msg.isIncomingMessage === 1 || msg.isIncomingMessage === '1' || msg.isIncomingMessage === true
    );
    const lastIncomingMessage = incomingMessages.length > 0 ? incomingMessages[incomingMessages.length - 1] : null;

    if (!lastIncomingMessage) {
      this.canReply = false;
      this.showCannotReplyWarning = true;
      this.replyWindowClosesAt = null;
      this.remainingTime = '';
      if (this.timeUpdateInterval) {
        clearInterval(this.timeUpdateInterval);
        this.timeUpdateInterval = null;
      }
      return;
    }

    const lastMessageTime = new Date(lastIncomingMessage.messagedAt || lastIncomingMessage.createdAt).getTime();
    const now = new Date().getTime();
    const twentyFourHours = 24 * 60 * 60 * 1000;
    const timeSinceLastMessage = now - lastMessageTime;
    this.canReply = timeSinceLastMessage <= twentyFourHours;
    this.showCannotReplyWarning = !this.canReply;

    if (this.canReply) {
      this.replyWindowClosesAt = new Date(lastMessageTime + twentyFourHours);
      this.updateRemainingTime();
      if (this.timeUpdateInterval) {
        clearInterval(this.timeUpdateInterval);
      }
      this.timeUpdateInterval = setInterval(() => {
        if (this.replyWindowClosesAt) {
          this.updateRemainingTime();
        }
      }, 60000);
    } else {
      this.replyWindowClosesAt = null;
      this.remainingTime = '';
      if (this.timeUpdateInterval) {
        clearInterval(this.timeUpdateInterval);
      }
    }
  }


  updateRemainingTime(): void {
    if (!this.replyWindowClosesAt) return;

    const now = new Date();
    const diff = this.replyWindowClosesAt.getTime() - now.getTime();

    if (diff <= 0) {
      this.canReply = false;
      this.showCannotReplyWarning = true;
      this.remainingTime = '';
      return;
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    this.remainingTime = `${hours} hours and ${minutes} minutes`;
  }

  isContactBlocked(): boolean {
    return Array.isArray(this.blockedUsers) && this.blockedUsers.includes(this.contactId);
  }

  addEmoji(event: any) {
    console.log('Emoji selected:', event.emoji.native);

    // Get current cursor position
    const textarea = this.msgInput.nativeElement;
    const cursorPosition = textarea.selectionStart;

    // Insert emoji at cursor position
    const textBefore = this.messageText.substring(0, cursorPosition);
    const textAfter = this.messageText.substring(cursorPosition);
    this.messageText = textBefore + event.emoji.native + textAfter;

    // // Close picker if not pinned
    // if (!this.stayOpen) {
    //   setTimeout(() => {
    //     this.hideEmojiPicker();
    //   }, 100);
    // }

    // Focus back on textarea and set cursor position
    setTimeout(() => {
      textarea.focus();
      const newPosition = cursorPosition + event.emoji.native.length;
      textarea.setSelectionRange(newPosition, newPosition);

      // Adjust height after adding emoji
      this.adjustTextAreaHeight(textarea);
    }, 50);
  }

  toggleEmojiPicker(event: Event) {
    event.stopPropagation();
    this.showEmojiPicker = !this.showEmojiPicker;
  }

  public uploader: FileUploader = new FileUploader({
    isHTML5: true,
    allowedFileType: ['image', 'video', 'txt', 'doc', 'pdf', 'xls', 'xlsx', 'docx']
  });


  selectMedia(type: string) {
    console.log('Selected:', type);

    const dialogRef = this.dialog.open(MediaPickerDialogComponent, {
      width: '600px',
      position: { top: '50px' },
      panelClass: 'custom-dialog-panel',
      data: { selectedType: type }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Received from dialog:', result);
        this.handleUploadedFile(result);
      }
    });
  }


  locations: any = "calsoftgroup.com";
  type: any = "whatsapp";

  public bannerServerPath = environment.commonImageApi + '/whatsapp/';

  handleUploadedFile(result: any) {
    let fileName = result.fileName;
    let caption = result.caption;
    if (!result || !result.fileName) {
      this.snackBar.open('Please upload the media', 'Close', {
        duration: 3000,
        panelClass: ['error']
      });
      return;
    }

    this.loaderService.show();
    const cid = localStorage.getItem(Constant.enterPriseKey);
    const fullPath = `${this.bannerServerPath}${fileName}&cid=${cid}`;
    const extension = fileName.split('.').pop()?.toLowerCase() || '';
    let mediaType: 'audio' | 'video' | 'image' | 'document' = 'document';

    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    const videoExtensions = ['mp4', 'mov', 'avi', 'webm', 'mkv'];
    const audioExtensions = ['mp3', 'wav', 'ogg', 'm4a'];
    const documentExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv'];

    if (imageExtensions.includes(extension)) {
      mediaType = 'image';
    } else if (videoExtensions.includes(extension)) {
      mediaType = 'video';
    } else if (audioExtensions.includes(extension)) {
      mediaType = 'audio';
    } else if (documentExtensions.includes(extension)) {
      mediaType = 'document';
    }

    const jsondata = {
      contactUid: this.contactUid,
      filepond: "undefined",
      uploadedMediaFileName: fileName,
      mediaType,
      mediaUrl: fullPath,
      caption: caption || ""
    };


    this.whatsappservice.sendMediaChat(jsondata).subscribe({
      next: (res) => {

        this.loaderService.hide();
        this.getChatConversionByPhoneno(this.phoneNo);
        if (this.contactUid) {
          //   this.loadChatMessages(this.selectedContact.uid);
        }
        console.log('Media sent successfully:', res);
      },
      error: (err) => {
        this.loaderService.hide();
        console.error('Error sending media:', err);
      }
    });
  }


  openMediaPicker() {
    const dialogRef = this.dialog.open(MediaPickerDialogComponent, {
      width: '600px',
      position: { top: '50px' },
      panelClass: 'custom-dialog-panel',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Received from dialog:', result);

        this.handleUploadedFile(result);
      }
    });

  }
  handleMediaUpload(event: any): void {
    const file = event.target.files[0];
    if (!file || !this.selectedContact) return;

    event.target.value = '';


    const mediaType = this.getMediaType(file.type);

    this.isSending = true;

    this.whatsappservice.sendMedia(file).subscribe({
      next: (uploadResponse) => {
        const body = {
          contactUid: this.contactUid,
          mediaType: mediaType,
          // uploadedMediaFileName: uploadResponse.fileName 
        };

        this.sendMediaMessage(body);
      },
      error: (error) => {
        console.error('Error uploading media:', error);
        this.isSending = false;
      }
    });
  }

  getMediaType(mimeType: string): string {
    if (mimeType.startsWith('image/')) {
      return 'IMAGE';
    } else if (mimeType.startsWith('video/')) {
      return 'VIDEO';
    } else if (mimeType.startsWith('audio/')) {
      return 'AUDIO';
    } else if (mimeType === 'application/pdf') {
      return 'DOCUMENT';
    } else if (
      mimeType === 'application/msword' ||
      mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ) {
      return 'DOCUMENT';
    } else if (
      mimeType === 'application/vnd.ms-excel' ||
      mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      return 'DOCUMENT';
    } else if (
      mimeType === 'application/vnd.ms-powerpoint' ||
      mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ) {
      return 'DOCUMENT';
    } else {
      return 'DOCUMENT'; // default to document for other file types
    }
  }

  sendMediaMessage(body: any): void {
    this.whatsappservice.sendMedia(body).subscribe({
      next: (response) => {
        console.log('Media message sent successfully:', response);
        if (this.selectedContact?.uid) {
          //this.loadChatMessages(this.selectedContact.uid);
        }
      },
      error: (error) => {
        console.error('Error sending media message:', error);
      },
      complete: () => {
        this.isSending = false;
      }
    });
  }

  onKeyUp(event: KeyboardEvent): void {
    const isMobile = window.innerWidth <= 768; // detect mobile view

    if (event.key === 'Enter' && !event.shiftKey) {
      if (isMobile) {
        // Mobile: Insert new line instead of sending
        event.preventDefault();
        const target = event.target as HTMLTextAreaElement;
        const cursorPos = target.selectionStart;
        this.messageText =
          this.messageText.slice(0, cursorPos) + '\n' + this.messageText.slice(cursorPos);

        // Move cursor after new line
        setTimeout(() => {
          target.selectionStart = target.selectionEnd = cursorPos + 1;
        });
      } else {
        // Desktop: Send message
        event.preventDefault();
        this.sendMessage();
      }
    }
  }

  getButtons(buttonsObj: any): string[] {
    if (!buttonsObj) return [];
    return Object.values(buttonsObj);
  }

  getDocumentIcon(extension: string): string {
    if (!extension) return 'insert_drive_file';

    const ext = extension.toLowerCase();

    if (ext === 'pdf') return 'picture_as_pdf';
    if (['xls', 'xlsx'].includes(ext)) return 'grid_on'; // or 'table_chart'
    if (['doc', 'docx'].includes(ext)) return 'description';
    if (['ppt', 'pptx'].includes(ext)) return 'slideshow';
    if (['txt', 'text'].includes(ext)) return 'notes';

    return 'insert_drive_file'; // fallback icon
  }

  downloadImage(path: string) {
    console.log(path);
    this.downloadImageService.downloadMediaByUrl(path);
  }


  openImage(src: string): void {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ImageZoomComponent, {
        width: '900px',
        height: '550px',
        data: { data: src }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {


      });

    }
    else {
      let dialogRef = this.dialog.open(ImageZoomComponent, {
        minWidth: '100vw', height: '100vh',
        data: { data: src }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {

      });
    }
  }

  isMessageHighlighted(messageUid: string): boolean {
    return this.highlightedMessageId === messageUid;
  }

  AssignedUser() {
    const dialogRef = this.dialog.open(WhatsAppAssigneUserComponent, {
      width: '400px',
      disableClose: true,
      data: this.selectedContact?.uid
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Dummy popup closed');
    });
  }


  closeChat() {
    this.selectedContact = null;
    this.selectedContactUid = null;
    this.whatsappMessageLog = [];
    let location = 'whatsAppChat';
    this.location.go(`${location}`)

    this.resetTextArea();
  }

  resetTextArea(): void {
    this.messageText = '';
    this.isLimitExceeded = false;
    this.showCharLimitPopup = false;

    const textAreaEl = this.msgInput?.nativeElement;
    if (textAreaEl) {
      textAreaEl.style.height = 'auto';
      textAreaEl.style.height = '50px';
    }
  }

  sendTemplateMessage(): void {
    console.log('Send Template Message');

    localStorage.removeItem('whatsappContactDetails');

    // Use contactId (or contactUid if your route expects that)
    if (this.contactId) {
      this.router.navigate([
        `/whatsAppContact/sendtemplate/${this.contactId}`
      ]);
    } else {
      console.warn('Contact ID not available');
    }
  }


  toggleSearchPanel() {
    this.searchQuery = ''; // Clear search when toggling
    this.showSearchPanel = !this.showSearchPanel;
  }

  goBack() {
    this.selectedContact = null;
    this.selectedContactUid = null;
    this.whatsappMessageLog = [];
    this.resetTextArea();
    let str = "false";
    localStorage.setItem("HideMainMenu", str);
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  private getFileExtension(url: string): string {
    if (!url) return '';
    const match = url.match(/\.([a-zA-Z0-9]+)(?=[?#]|$)/);
    return match ? match[1].toLowerCase() : '';
  }
  /**
   * Returns a cached blob URL for the given media URL.
   * On first call: kicks off a single HTTP fetch, returns '' while in-flight.
   * On subsequent calls: returns the cached blob URL immediately.
   * Non-CDN URLs are returned as-is with the cid cookie appended.
   */
  getMediaUrl(url: string): string {
    if (!url) return '';

    if (
      url.includes('lookaside.fbsbx.com') ||
      url.includes('fbsbx.com') ||
      url.includes('whatsapp_business/attachments') ||
      url.includes('scontent.whatsapp.net') ||
      url.includes('fbcdn.net')
    ) {
      if (this.mediaUrlCache.has(url)) {
        return this.mediaUrlCache.get(url)!;
      }

      if (!this.fetchingUrls.has(url)) {
        this.fetchingUrls.add(url);
        this.whatsappservice.getImageByUrl(url).subscribe({
          next: (blobUrl: string) => {
            this.mediaUrlCache.set(url, blobUrl);
            this.fetchingUrls.delete(url);
            this.cdr.markForCheck();
          },
          error: () => {
            this.fetchingUrls.delete(url);
          }
        });
      }

      return '';
    }

    // Non-CDN URLs: append cid cookie as before
    return url + this.cid;
  }

  parseSections(sectionsObj: any): any[] {
    if (!sectionsObj) return [];
    return Object.values(sectionsObj).map((section: any) => ({
      title: section.title,
      rows: section.rows ? Object.values(section.rows) : []
    }));
  }


  //  deleteChat(value) {

  //   this.whatsappBlockService.deleteByContactWaId(value.waId).subscribe(
  //     (res) => {

  //       console.log("res", res);

  //       this.getAllWhatssappChat();

  //     },
  //     (err) => {

  //     });

  // }

  // blockChat(value) {

  //   console.log("value", value);

  //   let object = {
  //     "users": [value.waId],
  //   }

  //   this.whatsappBlockService.blockNumber(object).subscribe(
  //     (res) => {

  //       console.log("res", res);
  //       this.isBlocked = 1;
  //       this.snackBar.open('Contact Blocked!', 'Close', {
  //         duration: 3000,
  //         verticalPosition: 'bottom',
  //         panelClass: 'success'
  //       });
  //       this.getAllWhatssappChat();
  //       if (this.selectedContact?.uid) {
  //         this.loadChatMessages(this.selectedContact.uid);
  //       }


  //     },
  //     (err) => {

  //     });

  // }


  // unblockChat(value) {

  //   let object = {
  //     "users": [value.waId ?? value.wa_id],
  //   }

  //   this.whatsappBlockService.UnblockNumber(object).subscribe(
  //     (res) => {
  //       this.snackBar.open('Contact unblocked!', 'Close', {
  //         duration: 3000,
  //         verticalPosition: 'bottom',
  //         panelClass: 'success'
  //       });
  //       this.dialog.closeAll();

  //       this.getAllBlockList();
  //       this.isBlocked = 0;
  //       if (this.selectedContact?.uid) {
  //         this.loadChatMessages(this.selectedContact.uid);
  //       }
  //     },
  //     (err) => {

  //     });

  // }

  //  getAllWhatssappChat() {
  //   this.unreadUserMessages = 0;
  //   if (this.whatsappContactId != undefined && this.whatsappVendorId != undefined) {
  //     this.whatsappservice.getContactsData(this.currentPage, this.pageSize, this.sort, this.whatsappContactId)
  //       .subscribe({
  //         next: (response) => {
  //           const newContacts = response.contacts || [];

  //           if (this.currentPage === 0) {
  //             this.contacts = newContacts;
  //             this.filteredContacts = [...newContacts];
  //           } else {
  //             this.contacts = [...this.contacts, ...newContacts];
  //             this.filteredContacts = [...this.contacts];
  //           }
  //           this.allContactsLoaded = response.nextPage === 0;
  //           // if (!this.allContactsLoaded) {
  //           //   this.currentPage = response.nextPage;
  //           // }



  //           this.isLoadingContacts = false;
  //           if (this.isScrolled == false) {

  //             const urlParams = new URLSearchParams(window.location.search);
  //             const contactIdFromUrl = urlParams.get('contact');

  //             if (contactIdFromUrl) {
  //               this.selectedContactUid = contactIdFromUrl;
  //               this.loadChatMessages(contactIdFromUrl);

  //               if (this.filteredContacts) {
  //                 const contactFromUrl = this.filteredContacts.find(contact => contact.uid === contactIdFromUrl);
  //                 if (contactFromUrl) {
  //                   this.selectedContact = contactFromUrl;
  //                 }
  //               }
  //             }

  //           }
  //           this.unreadUserMessages = this.filteredContacts.filter(
  //             contact => contact.unreadMessagesCount > 0
  //           ).length;

  //         },
  //         error: (error) => {
  //           console.error('Error loading contacts:', error);
  //           this.isLoadingContacts = false;
  //         },
  //         complete: () => {
  //           this.isScrolled = false;
  //           this.filterContacts();

  //         }
  //       });
  //   }
  // }

  // filteredContacts: any[] = [];
  // originalContacts: any[] = [];
  // activeTab = 'all';
  // isScrolled: boolean = false;
  // currentPage = 0;
  // pageSize = 10;
  // isLoadingContacts = false;
  // whatsappContactId: string;
  // sort = 'createdAt,desc';
  // allContactsLoaded = false;
  // contacts: any;
  // blockedContact: any;

  // filterContacts(): void {
  //   if (this.activeTab === 'all') {
  //     this.filteredContacts = [...this.contacts];
  //   } else if (this.activeTab === 'unread') {
  //     this.filteredContacts = this.contacts.filter(contact =>
  //       contact.unreadMessagesCount > 0
  //     );
  //   }
  // }


  // loadChatMessages(contactUid: string): void {

  //   if (this.whatsappVendorId != undefined) {
  //     this.whatsappservice.getAllWhatsAppChat(contactUid, this.page, this.size, this.sortParam)
  //       .subscribe((data: any) => {
  //         if (data && data.chatData && data.chatData.contactDetails && data.chatData.contactDetails.length > 0) {
  //           this.chatDetails = data.chatData.contactDetails[0];

  //           this.isBlocked = 0;


  //           if (this.chatDetails.isBlocked != undefined) {

  //             this.isBlocked = this.chatDetails.isBlocked;
  //           }

  //           //unread handle
  //           if (this.chatDetails.lastUnreadMessageCount > 0) {
  //             if (this.unreadUserMessages > 0) {
  //               this.unreadUserMessages--;
  //             }
  //           }

  //           console.log(this.isBlocked);

  //           if (this.chatDetails.whatsappMessageLog) {
  //             this.whatsappMessageLog = this.chatDetails.whatsappMessageLog;

  //             // Inside loadChatMessages()
  //             this.whatsappMessageLog = this.whatsappMessageLog.map(msg => {
  //               if (msg.data) {
  //                 try {
  //                   const parsed = JSON.parse(msg.data);
  //                   // if(parsed.initial_response){
  //                   //   let  initialResponse = parsed.webhook_responses ;
  //                   //     console.log(msg.id, initialResponse);

  //                   // }
  //                   // Update the message processing logic in loadChatMessages
  //                   if (parsed.interaction_message_data) {
  //                     const interactiveData = parsed.interaction_message_data;
  //                     msg.interactiveType = interactiveData.interactive_type;

  //                     // Create a consistent structure for interactive messages
  //                     msg.interactiveData = {
  //                       headerType: interactiveData.header_type,
  //                       mediaLink: interactiveData.media_link,
  //                       bodyText: interactiveData.body_text,
  //                       footerText: interactiveData.footer_text,
  //                       headerText: interactiveData.header_text,
  //                       buttons: interactiveData.buttons,
  //                       listData: interactiveData.list_data,
  //                       ctaData: interactiveData.cta_url
  //                     };

  //                     // Handle media if present
  //                     if (interactiveData.header_type && ['image', 'video', 'audio', 'document'].includes(interactiveData.header_type)) {
  //                       msg.media = {
  //                         mediaUrl: interactiveData.media_link,
  //                         extension: this.getFileExtension(interactiveData.media_link)
  //                       };
  //                     }
  //                     switch (msg.interactiveType) {
  //                       case 'button':
  //                         msg.buttonData = {
  //                           buttons: interactiveData.buttons,
  //                           bodyText: interactiveData.body_text,
  //                           footerText: interactiveData.footer_text,
  //                           headerText: interactiveData.header_text,
  //                           headerType: interactiveData.header_type,
  //                           mediaLink: interactiveData.media_link
  //                         };
  //                         break;

  //                       case 'list':
  //                         msg.listData = {
  //                           buttonText: interactiveData.list_data?.button_text,
  //                           sections: this.parseSections(interactiveData.list_data?.sections),
  //                           bodyText: interactiveData.body_text,
  //                           footerText: interactiveData.footer_text,
  //                           headerText: interactiveData.header_text
  //                         };
  //                         break;

  //                       case 'cta_url':
  //                         msg.ctaData = {
  //                           displayText: interactiveData.cta_url?.display_text,
  //                           url: interactiveData.cta_url?.url,
  //                           bodyText: interactiveData.body_text,
  //                           footerText: interactiveData.footer_text,
  //                           headerText: interactiveData.header_text
  //                         };
  //                         break;
  //                     }

  //                   }

  //                   if (parsed.template_proforma) {
  //                     const template = parsed.template_proforma;
  //                     const components = template.components || [];

  //                     // Extract all template components
  //                     msg.templateComponents = {};

  //                     components.forEach((comp: any) => {
  //                       switch (comp.type) {
  //                         case 'HEADER':
  //                           msg.templateComponents.header = {
  //                             type: comp.format?.toLowerCase() || 'text',
  //                             text: comp.text || '',
  //                             example: comp.example?.header_handle?.[0] || ''
  //                           };
  //                           break;
  //                         case 'BODY':
  //                           msg.templateComponents.body = comp.text || '';
  //                           break;
  //                         case 'FOOTER':
  //                           msg.templateComponents.footer = comp.text || '';
  //                           break;
  //                         case 'BUTTONS':
  //                           msg.templateComponents.buttons = comp.buttons || [];
  //                           break;
  //                       }
  //                     });
  //                     // If we have template components from webhook
  //                     if (parsed.template_components) {
  //                       msg.templateComponents = msg.templateComponents || {};

  //                       parsed.template_components.forEach((comp: any) => {
  //                         switch (comp.type) {
  //                           case 'HEADER':
  //                             msg.templateComponents.header = {
  //                               type: comp.format?.toLowerCase() || 'text',
  //                               text: comp.text || '',
  //                               example: comp.example?.header_handle?.[0] || '',
  //                               url: msg.templateComponents.header.url || ''
  //                             };

  //                             break;
  //                           case 'BODY':
  //                             msg.templateComponents.body = comp.text || '';
  //                             break;
  //                           case 'FOOTER':
  //                             msg.templateComponents.footer = comp.text || '';
  //                             break;
  //                           case 'BUTTONS':
  //                             msg.templateComponents.buttons = comp.buttons || [];
  //                             break;
  //                         }
  //                       });
  //                     }
  //                     // Handle template component values
  //                     if (parsed.template_component_values) {
  //                       parsed.template_component_values.forEach((compVal: any) => {
  //                         if (compVal.type === 'header' && compVal.parameters?.length) {
  //                           const param = compVal.parameters[0];
  //                           if (param.type === 'location') {
  //                             msg.templateComponents = msg.templateComponents || {};
  //                             msg.templateComponents.location = {
  //                               name: param.location?.name || '',
  //                               address: param.location?.address || '',
  //                               latitude: param.location?.latitude || '',
  //                               longitude: param.location?.longitude || ''
  //                             };
  //                           }

  //                           if (msg.templateComponents.header) {
  //                             if (param.image?.link) {
  //                               const originalUrl = param.image.link;

  //                               // Parse the URL
  //                               const urlObj = new URL(originalUrl);

  //                               // Delete all `cid` parameters
  //                               urlObj.searchParams.delete('cid');

  //                               // Get the cleaned URL
  //                               const cleanedUrl = urlObj.toString();

  //                               console.log(cleanedUrl);
  //                               msg.templateComponents.header.url = decodeURIComponent(cleanedUrl);
  //                             } else if (param.video?.link) {
  //                               const originalUrl = param.video.link;

  //                               // Parse the URL
  //                               const urlObj = new URL(originalUrl);

  //                               // Delete all `cid` parameters
  //                               urlObj.searchParams.delete('cid');

  //                               // Get the cleaned URL
  //                               const cleanedUrl = urlObj.toString();

  //                               console.log(cleanedUrl);
  //                               msg.templateComponents.header.url = decodeURIComponent(cleanedUrl);

  //                             } else if (param.document?.link) {
  //                               const originalUrl = param.document.link;

  //                               // Parse the URL
  //                               const urlObj = new URL(originalUrl);

  //                               // Delete all `cid` parameters
  //                               urlObj.searchParams.delete('cid');

  //                               // Get the cleaned URL
  //                               const cleanedUrl = urlObj.toString();

  //                               console.log(cleanedUrl);
  //                               msg.templateComponents.header.url = decodeURIComponent(cleanedUrl);

  //                             } else if (param.text) {
  //                               msg.templateComponents.header.text = param.text;
  //                             }
  //                           }
  //                         }
  //                         if (compVal.type === 'body' && compVal.parameters?.length) {
  //                           msg.templateComponents = msg.templateComponents || {};

  //                           parsed.template_components.forEach((comp: any) => {
  //                             if (comp.type === 'BODY' && comp.text) {
  //                               let bodyText = comp.text;

  //                               // Find matching component values for BODY
  //                               const bodyCompVal = parsed.template_component_values?.find(
  //                                 (val: any) => val.type?.toLowerCase() === 'body'
  //                               );

  //                               if (bodyCompVal?.parameters?.length) {
  //                                 // Normalize text (remove encoded braces)
  //                                 bodyText = bodyText.replace(/&#123;/g, '{').replace(/&#125;/g, '}');

  //                                 bodyCompVal.parameters.forEach((param: any, index: number) => {
  //                                   if (param.type === 'text' && param.text) {
  //                                     // Match {{ 1 }} with possible spaces
  //                                     const placeholder = new RegExp(`{{\\s*${index + 1}\\s*}}`, 'g');
  //                                     bodyText = bodyText.replace(placeholder, param.text.trim());
  //                                   }
  //                                 });
  //                               }

  //                               msg.templateComponents = msg.templateComponents || {};
  //                               msg.templateComponents.body = bodyText;
  //                             }
  //                           });
  //                         }
  //                       });
  //                     }
  //                   }


  //                   if (parsed.webhook_responses && msg?.message == "" && msg?.interactiveType?.length == 0) {
  //                     let incoming = parsed.webhook_responses.incoming[0];
  //                     let changes = incoming.changes[0];
  //                     let changesMessages = changes.value.messages[0];
  //                     let webHookText = changesMessages.text.body;
  //                     msg.WebHookText = webHookText;
  //                   }
  //                   const media = parsed.media_values;

  //                   if (media?.link && (media?.type || media?.mime_type)) {
  //                     let type = media.type;

  //                     if ((type === 'document' || !type) && media.mime_type) {
  //                       const mimeMain = media.mime_type.split('/')[0];
  //                       if (['image', 'video', 'audio'].includes(mimeMain)) {
  //                         type = mimeMain;
  //                       }
  //                     }

  //                     msg.mediaData = {
  //                       type,
  //                       url: media.link.trim(),
  //                       caption: media.caption || '',
  //                       mimeType: media.mime_type || ''
  //                     };

  //                     const extensionMatch = media.link.match(/\.([a-zA-Z0-9]+)(?=[?#]|$)/);
  //                     msg.mediaData.extension = extensionMatch ? extensionMatch[1].toLowerCase() : '';
  //                   } else {
  //                     msg.mediaData = null;
  //                   }
  //                 } catch (e) {
  //                   console.error('Error parsing message data', e);
  //                 }
  //               }
  //               return msg;
  //             });

  //             this.checkCanReply();
  //             setTimeout(() => {
  //               if (this.messagesContainer) {
  //                 const el = this.messagesContainer.nativeElement;
  //                 el.scrollTop = el.scrollHeight; // Instant, no animation
  //               }
  //             }, 0);
  //           } else {
  //             this.whatsappMessageLog = [];
  //           }
  //         } else {
  //           this.whatsappMessageLog = [];
  //         }
  //         this.focusMessageInput();
  //         this.showMainMeu = true;
  //         if (this.showMainMeu == true && this.mobileView) {
  //           let str = "true";
  //           localStorage.setItem("HideMainMenu", str);
  //         }
  //       });
  //   } else {
  //     this.whatsappMessageLog = [];
  //   }
  // }

  //  getAllBlockList() {
  //   this.whatsappBlockService.getUnblockList().subscribe(res => {

  //     console.log("res", res);

  //     this.blockedContact = res['data'];

  //     console.log("blockedContact", this.blockedContact);


  //   },
  //     error => {

  //     })
  // }

  //   focusMessageInput(): void {
  //   setTimeout(() => {
  //     if (this.msgInput && this.msgInput.nativeElement) {
  //       this.msgInput.nativeElement.focus();
  //     }
  //   }, 100);
  // }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
